import { useMemo } from 'react';
import { Option } from 'components/atoms/select/types';
import { useNativeActiveOrInvitedUsersQuery } from 'queries/members';
import { fullName } from 'utils/full-name';

export const useUserOptions = (approvees: number[]) => {
  const { data: nativeUsers = [] } = useNativeActiveOrInvitedUsersQuery();

  const userOptions: Option[] = useMemo(
    () =>
      nativeUsers
        .filter((user) => approvees.includes(user.userId))

        .map((user) => ({
          value: user.userId,
          label: fullName(user),
          description: user.role?.roleName,
          imageUrl: user.photoUrl,
        }))
        .sort((a, b) =>
          a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
        ),
    [nativeUsers, approvees],
  );

  return {
    users: nativeUsers,
    userOptions,
  };
};
